<div class="desktop-menu">

  @if (isBrianMode()) {
    <evc-nav-button class="go-to-iplex-btn" size="sm" type="link" variant="round" (click)="goToBrianApp()">
      <svg class="go-to-iplex-icon">
        <use xlink:href="assets/icons/goToIplex.svg#goToIplex" href="assets/icons/goToIplex.svg#goToIplex"/>
      </svg>
      <span class="go-to-iplex-text">{{ 'desktopMenu.backToIplex' | translate }}</span>
    </evc-nav-button>
  }

  <app-network-overlay />

  <app-iplex-g-connect-mode-overlay></app-iplex-g-connect-mode-overlay>
</div>
